import { configureStore } from "@reduxjs/toolkit";
import { baseApi } from "./baseApi";
// Import API slices to register their endpoints
import "./productsApi";
import "./categoriesApi";
import "./authApi";
import "./ordersApi";
import "./cartApi";
import "./couponsApi";

/**
 * Redux Store Configuration
 * Combines all API slices and any future reducers
 */
export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          // Ignore these action types if needed
        ],
      },
    }).concat(baseApi.middleware),
  devTools: import.meta.env.DEV,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

